<template>
  <a-layout id="designLayout">
    <a-layout-sider v-model="collapsed" style="overflow:hidden;padding-top:64px;" >
      <div class="logo">
        <img src="@/assets/logo.png">
      </div>
      <vue-scroll>
        <SideNav
          ref="previews"
          @show-canvas="showCanvas"
          @add="addCanvas"
          @remove-canvas="removeCanvas"
        />
      </vue-scroll>

    </a-layout-sider>

    <a-layout>
      <a-layout-header class="header" style="padding: 0">
        <HeadNav
          ref="headNav"
          :order-id="project.orderId"
          :project-id="project.id"
          :key="project.orderId"
          @setAlignment="setAlignment"
          @choosePicture="choosePicture"
          @switch-crop="switchCrop"
          @preview="popPreview"
          @save="save"
          @close="close"
          @submit="submitConfirm"
          @modify-order-info="modifyOrderInfo"
        />
      </a-layout-header>

      <a-layout-content
        :style="{ margin: '8px 5px', padding: '0', background: '#eee', height: '100%' }"
      >
        <CurtainCanvas v-for="canvas in canvasSet"
          v-show="canvas.id == activeId"
          ref="curtainCanvas"
          :canvas="canvas"
          :key="canvas.id"
          @preview-update="previewUpdate"
          @loaded="loadNextCanvas"
        />
        <!-- loading -->
        <a-spin class="loading" size="large" tip="正在加载..." v-show="loading" />
      </a-layout-content>
    </a-layout>

    <PopPreview ref="popPreview" />
    <SubmitConfirm
      ref="submitConfirm"
      :orderId="project.orderId"
      :canvasSet="canvasSet"
      @submit="submit"
    />
    <close-confirm ref="closeConfirm"/>
  </a-layout>
</template>

<script>
import CurtainCanvas from './CurtainCanvas'
import HeadNav from './Head'
import SideNav from './SideNav'
import PopPreview from './PopPreview'
import SubmitConfirm from './SubmitConfirm'
import CloseConfirm from './CloseConfirm.vue'
import projectModel from '@/api/project'

export default {
  name: 'Design',
  components: {
    HeadNav, SideNav, CurtainCanvas, PopPreview, SubmitConfirm, CloseConfirm
  },
  props: ['id'],
  data () {
    return {
      project: {
        // 订单编号
        orderId: '',
        content: []
      },
      collapsed: false,
      canvasSet: [],
      activeId: '',
      // 心跳
      keepalive: null,
      loading: true
    }
  },
  created () {
    this.update()
    this.keepalive = setInterval(_ => {
      projectModel.keepalive(this.id).then(_ => {}, this.onCheckoutError)
    }, 20000)
  },
  mounted () {
    // 关闭页面提醒
    window.onbeforeunload = function () {
      return '请确保保存改动之后再关闭页面. 是否继续?'
    }
  },
  destroyed () {
    if (this.keepalive) {
      clearInterval(this.keepalive)
      this.keepalive = null
    }
    window.onbeforeunload = undefined
  },
  computed: {
    activeCanvas () {
      const el = this.$refs.curtainCanvas.find(x => x.id === this.activeId)
      return el
    }
  },
  methods: {
    update () {
      const self = this
      this.loading = true
      projectModel.get(this.id).then(res => {
        this.loading = false
        self.project = res.data
        self.loadNextCanvas()
      }, this.onCheckoutError)
    },
    loadNextCanvas () {
      if (this.project.content && this.project.content.length) {
        const c = this.project.content.shift()
        this.canvasSet.push(c)
        this.activeId = c.id
      }
    },
    previewUpdate (data) {
      const {id, preview, option} = data

      let canvas = this.canvasSet.find(x => x.id === id)
      Object.assign(canvas.option, option)

      preview.id = id
      this.$refs.previews.update(preview)
    },
    showCanvas (id) {
      this.activeId = id
      this.activeCanvas.active()
    },
    addCanvas () {
      const id = 'C' + new Date().getTime()
      this.canvasSet.push({
        id: id,
        option: {
          fullPage: true,
          img: {
            url: 'static/images/white.gif',
            x: 0,
            y: 0,
            scale: 1
          },
          crop: {
          },
          frame: {
            width: 0,
            height: 0
          }
        },
        // 卷帘属性
        properties: {
          // 订单编号
          orderId: '11111',
          // 卷帘尺寸 cm
          width: 100,
          height: 100,
          curtainHead: 15,
          // 面料
          mianliao: {
            value: '',
            other: ''
          },
          face: '单面印',
          // 备注
          note: '',
          // 背景色
          bgColor: '#ffffff',
          cursorX: 0,
          cursorY: 0
        }
      })
      this.activeId = id
    },
    removeCanvas (id) {
      const i = this.canvasSet.findIndex(x => x.id === id)
      this.canvasSet.splice(i, 1)

      if (this.canvasSet.length > 0) {
        this.activeId = this.canvasSet[this.canvasSet.length - 1].id
      } else {
        this.activeId = ''
      }
    },
    setAlignment (type) {
      this.activeCanvas.setAlignment(type)
    },
    // 选择图片
    choosePicture (data) {
      this.activeCanvas.choosePicture(data)
    },
    // 显示/隐藏截图框
    switchCrop () {
      this.activeCanvas.switchCrop()
    },
    // 大图预览
    popPreview () {
      const canvas = this.canvasSet.find(x => x.id === this.activeId)
      this.$refs.popPreview.show({
        img: canvas.option.img,
        cropX: canvas.option.crop.x,
        cropY: canvas.option.crop.y,
        cropW: canvas.option.crop.cropW,
        cropH: canvas.option.crop.cropH,

        frameX: canvas.option.frame.x,
        frameY: canvas.option.frame.y,
        frameWidth: canvas.option.frame.width,
        frameHeight: canvas.option.frame.height,
        colorX: canvas.properties.cursorX,
        colorY: canvas.properties.cursorY
      })
    },
    // 修改订单编号
    modifyOrderInfo (orderInfo) {
      this.project.orderId = orderInfo.orderId
    },
    // 保存设计
    async save () {
      const self = this
      const toolbar = this.$refs.headNav
      try {
        await projectModel.save(this.id, this.project, this.canvasSet)
        self.$message.info('已保存')
      } finally {
        toolbar.$data.saving = false
      }
    },
    async close () {
      // 提示是否保存
      this.$refs.closeConfirm.confirm({
        onSave: async () => {
          try {
            await projectModel.save(this.id, this.project, this.canvasSet)
            await projectModel.close(this.id)
          } finally {
            this.$refs.closeConfirm.$data.saving = false
            this.$router.push('/')
          }
        },
        onDiscard: async () => {
          try {
            await projectModel.close(this.id)
          } catch (e) {} finally { this.$router.push('/') }
        }
      })
    },
    // 提交生成前确认
    submitConfirm () {
      this.$refs.submitConfirm.show(this.canvasSet)
    },
    // 提交生产
    submit () {
      this.$refs.headNav.$data.applying = true
      this.loading = true
      projectModel.apply(this.id, this.project, this.canvasSet).then(res => {
        this.loading = false
        // on Windows
        if (/Win/i.test(window.navigator.platform) && res.data) {
          res.data = res.data.map(item => '\\\\nas.cnblind.local' + item.replaceAll('/', '\\'))
        }
        // 成功通知
        this.$notification.open({
          message: '已生成文件',
          description: `文件已保存至 NAS ${res.data}`,
          duration: 0,
          icon: <a-icon type="smile" style="color: green" />
        })
        this.$refs.headNav.$data.applying = false
      }, _ => {
        this.$refs.headNav.$data.applying = false
        this.loading = false
      })
    },
    onCheckoutError (err) {
      this.loading = false
      const self = this
      // 资源被锁定
      if (err.status === 423) {
        clearInterval(self.keepalive)
        this.$error({
          title: '提示',
          content: err.data.message,
          onOk () { self.$router.push('/') }
        })
      }
    }
  }
}
</script>

<style scoped>
.logo{width:128px;height:64px;margin:8px;position:absolute;top:0;left:0;}
.logo img{width:100%;}
.header .trigger {float:left;color:#fff;position: relative;top:26px;}
#designLayout{height:100%;}
.loading{position: absolute;bottom:50%;left:50%;}
</style>



// WEBPACK FOOTER //
// src/pages/design/Design.vue